module.exports = __webpack_public_path__ + "static/img/082_TO8_1730_og.7d4d7dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/082_TO8_1730_og.jpg
// module id = 5sBx
// module chunks = 0